import pageProps from '@/layout/pageProps';

import { getStoriesList, getStoriesDetail } from '@/utils/api/SSRRequest';

import StoriesPage from './index';

export async function getServerSideProps(props) {
  const defaultProps = await pageProps(props);

  const [listRes, detailRes] = await Promise.allSettled([
    getStoriesList({ lang: props.locale }),
    getStoriesDetail({ id: props.query.id }),
  ]);
  return {
    props: { ...defaultProps, apiData: { listData: listRes.value.data || null, detailData: detailRes.value.data || null } },
  };
}

export default StoriesPage;
